import { useCallback, useEffect, useRef, useState } from 'react';
import { getBatches } from '@/services/tap.service.js';

// Loads the TAP batch inventory. `agent` scopes to one broker (Phase 1: omit
// for unfiltered). refresh() is called by mutations (mint) for an immediate
// re-pull.
export default function useTapBatches({ agent } = {}) {
  const [batches, setBatches] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    try {
      const d = await getBatches({ agent });
      if (!aborted.current) {
        setBatches(d?.batches || []);
        setError(null);
      }
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, [agent]);

  useEffect(() => {
    aborted.current = false;
    refresh();
    return () => { aborted.current = true; };
  }, [refresh]);

  return { batches, error, loading, refresh };
}
